import { render, staticRenderFns } from "./NotificationMgmt.vue?vue&type=template&id=0391e025&scoped=true"
import script from "./NotificationMgmt.vue?vue&type=script&lang=ts"
export * from "./NotificationMgmt.vue?vue&type=script&lang=ts"
import style0 from "./NotificationMgmt.vue?vue&type=style&index=0&id=0391e025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391e025",
  null
  
)

export default component.exports